import React from 'react';
import { 
  BarChart3, 
  Upload, 
  Users, 
  FileText, 
  Send, 
  Activity, 
  Zap, 
  Award,
  UserPlus,
  Settings,
  MessageSquare
} from 'lucide-react';

const Sidebar = ({ 
  currentPage, 
  setCurrentPage, 
  contactsTotal, 
  templates, 
  campaigns, 
  deliverabilityScore,
  onLogout,
  userEmail
}) => {
  const contactBadge = typeof contactsTotal === 'number' ? contactsTotal.toLocaleString() : '0';
  const templateBadge = templates.length.toLocaleString();
  const campaignBadge = campaigns.length.toLocaleString();
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'upload', label: 'Upload', icon: Upload },
    { id: 'contacts', label: 'Contacts', icon: Users, badge: contactBadge },
    { id: 'templates', label: 'Templates', icon: FileText, badge: templateBadge },
    { id: 'campaigns', label: 'Campaigns', icon: Send, badge: campaignBadge },
    { id: 'sms-replies', label: 'SMS replies', icon: MessageSquare },
    { id: 'team', label: 'Team', icon: UserPlus },
    { id: 'settings', label: 'Settings', icon: Settings },
    { id: 'reports', label: 'Reports', icon: Activity }
  ];

  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-white shadow-2xl border-r border-gray-200 z-50 overflow-y-auto">
      {/* Logo/Brand */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl shadow-lg">
            <Zap className="text-white" size={24} />
          </div>
          <div>
            <h1 className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              MarketReach
            </h1>
            <p className="text-xs text-gray-600">A TradeIT Platform</p>
          </div>
        </div>
      </div>
      
      {/* Navigation Menu */}
      <nav className="p-4 space-y-1">
        {menuItems.map(item => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setCurrentPage(item.id)}
              className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-300 ${
                currentPage === item.id
                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg scale-105'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <div className="flex items-center gap-3">
                <Icon size={20} />
                <span className="font-semibold">{item.label}</span>
              </div>
              {item.badge !== undefined && (
                <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                  currentPage === item.id 
                    ? 'bg-white text-indigo-600' 
                    : 'bg-gray-200 text-gray-700'
                }`}>
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Deliverability Score Widget */}
      <div className="p-4 border-t border-gray-200 space-y-4">
        <div className="p-4 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <Award className="text-indigo-600" size={20} />
            <span className="font-bold text-gray-900">Deliverability</span>
          </div>
          <div className="text-2xl font-bold text-indigo-600 mb-1">
            {typeof deliverabilityScore === 'number' ? `${deliverabilityScore}/100` : '—'}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
            <div 
              className="bg-gradient-to-r from-indigo-500 to-purple-500 h-2 rounded-full transition-all duration-500"
              style={{ width: `${typeof deliverabilityScore === 'number' ? deliverabilityScore : 0}%` }}
            ></div>
          </div>
          {typeof deliverabilityScore === 'number' ? (
            <button
              onClick={() => setCurrentPage('reports')}
              className="text-xs text-indigo-700 hover:text-indigo-800 font-semibold"
            >
              View Insights →
            </button>
          ) : (
            <span className="text-xs text-gray-500 font-semibold">No deliverability data</span>
          )}
        </div>
        {onLogout && (
          <div className="rounded-xl bg-white border border-gray-200 p-4 shadow-sm">
            <div className="text-xs uppercase font-semibold text-gray-500">Signed in as</div>
            <div className="text-sm font-semibold text-gray-900 break-words mt-1">{userEmail}</div>
            <button
              onClick={onLogout}
              className="mt-3 w-full rounded-lg border border-indigo-200 px-4 py-2 text-sm font-semibold text-indigo-600 transition hover:bg-indigo-50"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
